import escapeHtml from 'escape-html';
import { Text } from 'slate';

require('es6-promise').polyfill();

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

var serializeNode = function serializeNode(node) {
  if (Text.isText(node) && node.type !== 'paragraph' && node.type !== 'p') {
    var styleTagToOutput = '';

    if (node.fontFamily && node.fontFamily !== 'unset') {
      styleTagToOutput += "font-family: ".concat(node.fontFamily, ";");
    }

    if (node.fontSize) {
      styleTagToOutput += "font-size: ".concat(node.fontSize, "px;");
    }

    if (node.color) {
      styleTagToOutput += "color: ".concat(node.color, ";");
    }

    if (node.backgroundColor) {
      styleTagToOutput += "background-color: ".concat(node.backgroundColor, ";");
    }

    if (node.textAlign) {
      styleTagToOutput += "text-align: ".concat(node.textAlign, ";");
    }

    if (node['heading-one'] || node['h1']) {
      return "<h1 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h1>");
    }

    if (node['heading-two'] || node['h2']) {
      return "<h2 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h2>");
    }

    if (node['heading-three'] || node['h3']) {
      return "<h3 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h3>");
    }

    if (node['heading-four'] || node['h4']) {
      return "<h4 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h4>");
    }

    if (node['heading-five'] || node['h5']) {
      return "<h5 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h5>");
    }

    if (node['heading-six'] || node['h6']) {
      return "<h6 style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</h6>");
    }

    if (node['bold']) {
      return "<strong style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</strong>");
    }

    if (node['italic']) {
      return "<em style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</em>");
    }

    if (node['underline']) {
      return "<u style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</u>");
    }

    if (node['strikethrough']) {
      return "<del style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</del>");
    }

    if (node['code']) {
      return "<code style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</code>");
    }

    if (node['inline-code']) {
      return "<code style=\"".concat(styleTagToOutput, "\">").concat(node.text, "</code>");
    }

    return escapeHtml(node.text);
  }

  if (node.children) {
    var children = node.children.map(function (n) {
      return serializeNode(n);
    }).join('');
    var _styleTagToOutput = '';

    if (node.children[0].fontFamily && node.fontFamily !== 'unset') {
      _styleTagToOutput += "font-family: ".concat(node.children[0].fontFamily, ";");
    }

    if (node.children[0].fontSize) {
      _styleTagToOutput += "font-size: ".concat(node.children[0].fontSize, "px;");
    }

    if (node.children[0].color) {
      _styleTagToOutput += "color: ".concat(node.children[0].color, ";");
    }

    if (node.children[0].backgroundColor) {
      _styleTagToOutput += "background-color: ".concat(node.children[0].backgroundColor, ";");
    }

    if (node.textAlign) {
      _styleTagToOutput += "text-align: ".concat(node.textAlign, ";");
    }

    switch (node.type) {
      case 'container':
        return "<div style=\"".concat(_styleTagToOutput, "\">").concat(children, "</div>");

      case 'table':
        return "<table class=\"wig-loaded-table\" style=\"".concat(_styleTagToOutput, "\" data-attribute-headerColumn=\"").concat(node.headerColumn ? 'true' : 'false', "\" data-attribute-headerRow=\"").concat(node.headerRow ? 'true' : node.headerRow === undefined ? 'true' : 'false', "\" data-attribute-borderless=\"").concat(node.borderless ? 'true' : 'false', "\"  data-attribute-tableLayoutFixed=\"").concat(node.tableLayoutFixed ? 'true' : node.tableLayoutFixed === undefined ? 'true' : 'false', "\">\n            <tbody>").concat(children, "</tbody>\n          </table>");

      case 'table-row':
        return "<tr style=\"".concat(_styleTagToOutput, "\">").concat(children, "</tr>");

      case 'table-cell':
        return "<td width=\"".concat(node.colWidth || '100%', "\" style=\"").concat(_styleTagToOutput, "\">").concat(children, "</td>");

      case 'heading-one':
        return "<h1 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h1>");

      case 'heading-two':
        return "<h2 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h2>");

      case 'heading-three':
        return "<h3 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h3>");

      case 'heading-four':
        return "<h4 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h4>");

      case 'heading-five':
        return "<h5 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h5>");

      case 'heading-six':
        return "<h6 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h6>");

      case 'h1':
        return "<h1 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h1>");

      case 'h2':
        return "<h2 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h2>");

      case 'h3':
        return "<h3 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h3>");

      case 'h4':
        return "<h4 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h4>");

      case 'h5':
        return "<h5 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h5>");

      case 'h6':
        return "<h6 style=\"".concat(_styleTagToOutput, "\">").concat(children, "</h6>");

      case 'quote':
        return "<blockquote style=\"".concat(_styleTagToOutput, "\"><p>").concat(children, "</p></blockquote>");

      case 'block-quote':
        return "<blockquote style=\"".concat(_styleTagToOutput, "\"><p>").concat(children, "</p></blockquote>");

      case 'blockquote':
        return "<blockquote style=\"".concat(_styleTagToOutput, "\"><p>").concat(children, "</p></blockquote>");

      case 'paragraph':
        return "<p style=\"".concat(_styleTagToOutput, "\">").concat(children, "</p>");

      case 'p':
        return "<p style=\"".concat(_styleTagToOutput, "\">").concat(children, "</p>");

      case 'link':
        return "<a class=\"".concat(node.display === 'button' ? 'wig-link wig-link-button btn btn-primary' : 'wig-link', "\" title=\"").concat(node.title, "\" target=\"").concat(node.target, "\" rel=\"").concat(node.nofollow ? 'nofollow' : '', " ").concat(node.target && node.target === '_blank' ? 'noopener' : '', "\" style=\"").concat(_styleTagToOutput, "\" href=\"").concat(validateEmail(node.url) ? "mailto:".concat(node.url) : node.url, "\">").concat(children, "</a>");

      case 'a':
        return "<a style=\"".concat(_styleTagToOutput, "\" href=\"").concat(validateEmail(node.url) ? "mailto:".concat(node.url) : node.url, "\">").concat(children, "</a>");

      case 'align-center':
        return "<p style=\"".concat(_styleTagToOutput, "\" align=\"center\">").concat(children, "</p>");

      case 'align-left':
        return "<p style=\"".concat(_styleTagToOutput, "\" align=\"left\">").concat(children, "</p>");

      case 'align-right':
        return "<p style=\"".concat(_styleTagToOutput, "\" align=\"right\">").concat(children, "</p>");

      case 'bulleted-list':
        return "<ul style=\"".concat(_styleTagToOutput, "\">").concat(children, "</ul>");

      case 'unordered-list':
        return "<ul style=\"".concat(_styleTagToOutput, "\">").concat(children, "</ul>");

      case 'ordered-list':
        return "<ol style=\"".concat(_styleTagToOutput, "\">").concat(children, "</ol>");

      case 'numbered-list':
        return "<ol style=\"".concat(_styleTagToOutput, "\">").concat(children, "</ol>");

      case 'list-item':
        return "<li style=\"".concat(_styleTagToOutput, "\">").concat(children, "</li>");

      case 'todo-item':
        return "<div style=\"".concat(_styleTagToOutput, "\"\n          class={\"todo-list-item\"}\n          data-todo-complete=").concat(node.complete, "\n        >\n          <input type=\"checkbox\" ").concat(node.complete ? 'checked' : '', " disabled/>\n          ").concat(children, "\n          <span class=\"due-date\">").concat(node.dueDate, "</span>\n        </div>");

      case 'file':
        return "<a style=\"".concat(_styleTagToOutput, "\" className=\"ap-file-component\" target=\"_blank\" href=\"").concat(validateEmail(node.url) ? "mailto:".concat(node.url) : node.url, "\">\n              <div className=\"ap-file-component-extension\">\n                ").concat(node.extension, "\n              </div>\n              <div className=\"ap-file-component-filename\">").concat(node.filename, "</div>\n            </a>");

      case 'iframe':
        return "<div\n            style=\"".concat(_styleTagToOutput, " position: relative\"\n          >\n            <iframe\n              class=\"responsive-iframe\"\n              title=\"External service\"\n              src=").concat(node.url, "\n              frameBorder=\"0\"\n              style=\"\n                position: relative;\n                width: 100%;\n                height: auto;\n                minHeight: 350px;\n              \"\n            />\n          </div>\n          ").concat(children);

      case 'weduc-login':
        return "<div\n            style=\"".concat(_styleTagToOutput, " position: relative\"\n          >\n            <iframe\n              class=\"responsive-iframe weduc-login\"\n              title=\"Login with Weduc\"\n              src=").concat(node.url, "\n              frameBorder=\"0\"\n              style=\"\n                position: relative;\n                width: 100%;\n                height: auto;\n                minHeight: 550px;\n              \"\n            />\n          </div>\n          ").concat(children);

      case 'microsoft-form':
        return "<div\n            style=\"".concat(_styleTagToOutput, " position: relative\"\n          >\n            <iframe\n              id=\"microsoft-form\"\n              class=\"responsive-iframe microsoft-form\"\n              title=\"Please fill in this form\"\n              src=").concat(node.url, "\n              frameBorder=\"0\"\n              style=\"\n                position: relative;\n                width: 100%;\n                height: auto;\n                minHeight: 550px;\n              \"\n            />\n          </div>\n          ").concat(children);

      case 'google-form':
        return "<div\n            style=\"".concat(_styleTagToOutput, " position: relative\"\n          >\n            <iframe\n              id=\"google-form\"\n              class=\"responsive-iframe google-form\"\n              title=\"Please fill in this form\"\n              src=").concat(node.url, "\n              frameBorder=\"0\"\n              style=\"\n                position: relative;\n                width: 100%;\n                height: auto;\n                minHeight: 550px;\n              \"\n            />\n          </div>\n          ").concat(children);

      case 'image':
        if (node.link || (node.data && node.data.link ? node.data.link : false)) {
          return "<div class=\"image-position-".concat(node.position || 'Full', " ").concat(node.data && node.data.classname ? node.data.classname : node.className ? node.className : node.classname ? node.classname : '', "\">\n            <div style=\"").concat(_styleTagToOutput, " width: 100%; max-width: ").concat(node.resizedWidth || '100%', "\">\n            <a className=\"image-link-wrap\" href=\"").concat(validateEmail(node.link || node.data.link) ? "mailto:".concat(node.data && node.data.link ? node.data.link : false) : node.data && node.data.link ? node.data.link : false, "\">\n              <img\n                alt=\"").concat(node.alt || 'An image', "\"\n                src=\"").concat(node.url, "\"\n                width=").concat(node.width ? parseInt(node.width.replace(/\D/g, ''), 10) : null, "\n                height=").concat(node.height ? parseInt(node.height.replace(/\D/g, ''), 10) : null, "\n              />\n            </a>\n            ").concat(children, "\n            </div>\n          </div>");
        } else {
          return "<div class=\"image-position-".concat(node.position || 'Full', " ").concat(node.data && node.data.classname ? node.data.classname : node.className ? node.className : node.classname ? node.classname : '', "\">\n            <div style=\"").concat(_styleTagToOutput, " width: 100%; max-width: ").concat(node.resizedWidth || '100%', "\">\n            <img\n              alt=\"").concat(node.alt || 'An image', "\"\n              src=\"").concat(node.url, "\"\n              width=").concat(node.width ? parseInt(node.width.replace(/\D/g, ''), 10) : null, "\n              height=").concat(node.height ? parseInt(node.height.replace(/\D/g, ''), 10) : null, "\n            />\n            ").concat(children, "\n            </div>\n          </div>");
        }

      case 'img':
        if (node.link) {
          return "<div class=\"image-position-".concat(node.position || 'Full', " ").concat(node.data && node.data.classname ? node.data.classname : node.className ? node.className : node.classname ? node.classname : '', "\">\n            <div style=\"").concat(_styleTagToOutput, " width: 100%; max-width: ").concat(node.resizedWidth || '100%', "\">\n            <a className=\"image-link-wrap\" href=\"").concat(validateEmail(node.link) ? "mailto:".concat(node.link) : node.link, "\">\n              <img\n                alt=\"").concat(node.alt || 'An image', "\"\n                src=\"").concat(node.url, "\"\n                width=").concat(node.width ? parseInt(node.width.replace(/\D/g, ''), 10) : null, "\n                height=").concat(node.height ? parseInt(node.height.replace(/\D/g, ''), 10) : null, "\n              />\n            </a>\n            ").concat(children, "\n            </div>\n          </div>");
        }

        return "<div class=\"image-position-".concat(node.position || 'Full', " ").concat(node.data && node.data.classname ? node.data.classname : node.className ? node.className : node.classname ? node.classname : '', "\">\n            <div style=\"").concat(_styleTagToOutput, " width: 100%; max-width: ").concat(node.resizedWidth || '100%', "\">\n          <img\n            alt=\"").concat(node.alt || 'An image', "\"\n            src=\"").concat(node.url, "\"\n            width=").concat(node.width ? parseInt(node.width.replace(/\D/g, ''), 10) : null, "\n            height=").concat(node.height ? parseInt(node.height.replace(/\D/g, ''), 10) : null, "\n          />\n          ").concat(children, "\n          </div>\n        </div>");

      default:
        return "".concat(children);
    }
  }
};

var isJsonString = function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

export { isJsonString, serializeNode };